/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCartItemRequestSchema } from "./banquetCartItemRequestSchema.ts";

export const banquetCartComboGroupRequestSchema = z.object({
	id: z.uuid(),
	item: banquetCartItemRequestSchema,
});
